<template>
	<flickity ref="flickity" :options="flickityOptions" class="golf-header-carousel">
		<slot></slot>
	</flickity>
</template>

<script>
	import FlickityimagesLoaded from 'flickity-imagesloaded';
	import Flickity from 'vue-flickity';

	export default {

		components: {
			Flickity,
		},

		data () {
			return {
				flickityOptions: {
					imagesLoaded: true,
					wrapAround: true,
					adaptiveHeight: true,
					percentPosition: false,
					//autoPlay: 4000,
					cellSelector: '.golf-header-carousel-cell',
					prevNextButtons: false,
					pageDots: false,
					dragThreshold: 10,
					draggable: false,
				}
			}
		},

		mounted() {

		},

	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GolfHeaderCarousel.vue